const dateNow = new Date();
export const currentYear = dateNow.getFullYear();
